import CustomTabs from "components/Shared/CustomTabs";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useSearchParams } from "react-router-dom";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import { useBranchDetailContext } from "contexts/BranchDetailContext";
import ServicesTab from "./ServicesTab";
import BranchAdditionalNumberTab from "./BranchAdditionalNumberTab";

export const BranchDetailTabs = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "services";
  const { branchDetail, loadingDetail } = useBranchDetailContext();

  const tabs = [
    {
      label: "Services",
      value: "services",
    },
    {
      label: "Additional Numbers",
      value: "additionalNumbers",
    },
  ];
  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {!loadingDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="services">
            <ServicesTab branchDetail={branchDetail} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="additionalNumbers">
            <BranchAdditionalNumberTab branchDetail={branchDetail} />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default BranchDetailTabs;
